export const enum WACallsEventTypes {
  INCOMMING_CALL = 'incoming-call',
  CALL_TERMINATE = 'call-terminate',
  CALL_PICKED = 'call-picked',
}

export type WACallPayload = WACallIncomingPayload | WACallTerminatePayload | WACallPickedPayload;

export interface WACallIncomingPayload {
  event: WACallsEventTypes.INCOMMING_CALL;
  customerName: string;
  customerNumber: string;
  wabaNumber: string;
  wabaName: string;
  callId: string;
  sdp: string;
  sdpType: string;
  startTimestamp: string;
  expiryTimestamp: number;
}

export interface WACallTerminatePayload {
  event: WACallsEventTypes.CALL_TERMINATE;
  callId: string;
  duration: number;
  direction: 'USER_INITIATED';
  startTime: string;
  endTime: string;
  expiryTime?: number;
}

export interface WACallTerminateCustomPayload {
  callId: string;
  duration: number;
  direction: 'USER_INITIATED';
  startTime: string;
  endTime: string;
  expiryTime?: number;
}

export interface WACallPickedPayload {
  event: WACallsEventTypes.CALL_PICKED;
  callId: string;
  userId: string;
  expiryTime?: number;
}

export enum CallDirection {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}
export enum CallStatusFromBE {
  INITIATED = 'INITIATED',
  IN_PROGRESS ='IN_PROGRESS',
  END = 'END',
  MISSED = 'MISSED',
  FAILED = 'FAILED',
  REJECT = 'REJECT'
}

export enum CallStatus {
  INITIATED = 'INITIATED',
  Connecting = 'connecting',
  IN_PROGRESS ='IN_PROGRESS',
  END = 'END',
  MISSED = 'MISSED',
  FAILED= 'FAILED',
  REJECT = 'REJECT'
}

export type CallDisconnectStatus = CallStatus.END | CallStatus.MISSED | CallStatus.FAILED
export interface Call {
  customerName: string;
  customerNumber: string;
  wabaNumber: string;
  wabaName: string;
  callId: string;
  sdp: string;
  sdpType: string;
  status: CallStatus;
  shouldForceDisconnect?: boolean;
  shouldAnswerCall?: boolean;
  reconnect?: boolean;
  dateCreated?: string; // time when call was created (INITIATED)
  expiryTimestamp?: number; // timestamp in ms when the call will expire
}

export interface CallWithTimestamp extends Call {
  callStartTime?: number;
}

enum SdpPayloadType {
  OFFER = 'offer',
  ANSWER = 'answer',
}

export type SdpPayload = {
  sdp: string;
  type: SdpPayloadType;
}

export type CallFromUpdatesApiMetadata = {
  offerForCallee: SdpPayload;
}
export type CallFromUpdatesApi = {
  id: string;
  customerName: string;
  customerNumber: string;
  wabaNumber: string;
  wabaName: string;
  callId: string;
  customerId: string;
  integrationId: string;
  orgId: string;
  pickedBy: string;
  currentOnCallUser: string;
  status: CallStatus;
  recordingUrl: string | null;
  callOriginType: CallDirection;
  callStartedAt: string | null; // this will be null for INITIATED calls
  callEndedAt: string | null;
  dateCreated: string;
  dateUpdated: string;
  chatMessageId: string;
  durationInSeconds: number | null; // this will be only for ENDED calls
  metadata: CallFromUpdatesApiMetadata
}

export interface CallPopupProps {
  callData: Call;
  handleAcceptCall: (call: Call) => void;
  onAccept: (state: CallStatus) => void;
  onReject: () => void;
  onDisconnect: () => void;
  onMinimize?: () => void;
  style?: React.CSSProperties;
}

export interface AnswerIncommingCallApiType {
  callId: string;
  sdp: string;
  sdpType: string;
  reconnect?: boolean
}


export type ReconnectSDPResponse = {
  success: boolean,
  message: string,
  data: SdpPayload
}